import React, { useState } from 'react';
import { useData } from '../DataContext';
import { useLang } from '../LanguageContext';
import { useNavigate } from 'react-router-dom'; // 페이지 이동 훅
import { FileText, Calendar, RotateCcw, Search, Eye, Printer, X } from 'lucide-react';

// --- [정산서 상세 모달] ---
const SettlementDetailModal = ({ game, agent, onClose }) => {
  if (!game) return null;

  const fmt = (num) => num ? Math.floor(Number(num)).toLocaleString() : '0';

  const calculateSheet = (g) => {
    const totalChipsBuy = parseFloat(g.sumBuyIn || 0);
    const totalCashOut = parseFloat(g.sumCashOut || 0);
    const gameWinLoss = totalChipsBuy - totalCashOut;
    
    const rollingAmount = parseFloat(g.totalRolling || 0);
    const commRate = parseFloat(g.rollingComm || 0);
    const rollingComm = Math.floor(rollingAmount * (commRate / 100));
    
    let netWinLoss = 0;
    let shareProfit = 0;

    if (g.type === 'Share') {
      netWinLoss = gameWinLoss - rollingComm;
      const shareRate = parseFloat(g.shareRate || 0);
      shareProfit = Math.floor(netWinLoss * (shareRate / 100));
    }
    return { totalChipsBuy, totalCashOut, gameWinLoss, rollingAmount, rollingComm, netWinLoss, shareProfit };
  };

  const calc = calculateSheet(game);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div id="print-overlay" style={{ 
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', 
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1200 
    }}>
      <div id="print-sheet" style={{ 
        backgroundColor: 'white', 
        width: '800px',        
        maxHeight: '90vh',     
        padding: '40px',       
        borderRadius: '8px', 
        boxShadow: '0 20px 50px rgba(0,0,0,0.3)', 
        position:'relative',
        overflowY: 'auto'      
      }}>
        
        {/* 헤더 영역 */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'30px', borderBottom:'2px solid #0f172a', paddingBottom:'20px' }}>
          <div style={{ width:'120px', height:'60px', backgroundColor:'#e2e8f0', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold', color:'#64748b' }}>
            LOGO
          </div>
          <div style={{ textAlign:'right' }}>
            <h1 style={{ margin:0, fontSize:'28px', color:'#0f172a', letterSpacing:'1px', textTransform:'uppercase' }}>Settlement Sheet</h1>
            <p style={{ margin:'5px 0', fontSize:'16px', fontWeight:'bold', color:'#2563eb' }}>
              GAME: {game.id} &nbsp;|&nbsp; AGENT: {game.agentId}
            </p>
            <p style={{ margin:0, color:'#64748b', fontSize:'14px' }}>Date: {new Date().toLocaleDateString()}</p>
            <p style={{ margin:0, color:'#64748b', fontSize:'14px' }}>Staff: {game.settledBy || '-'}</p>
          </div>
        </div>

        {/* 계산 내역 영역 */}
        <div style={{ marginBottom:'40px', border:'1px solid #e2e8f0', borderRadius:'8px', padding:'20px' }}>
            
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>Total Chips Buy</span>
              <span style={{ fontWeight:'bold' }}>{fmt(calc.totalChipsBuy)}</span>
            </div>
            {/* [Label Change] Total Cash Out -> Total Chips Out */}
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>Total Chips Out</span>
              <span style={{ fontWeight:'bold' }}>{fmt(calc.totalCashOut)}</span>
            </div>
            
            <div style={{ display:'flex', justifyContent:'space-between', padding:'12px 15px', borderTop:'1px solid #cbd5e1', borderBottom:'1px solid #cbd5e1', marginBottom:'20px', background:'#f8fafc', borderRadius:'4px' }}>
              <span style={{ fontWeight:'bold', color:'#334155' }}>Game Win/Loss</span>
              <span style={{ fontWeight:'bold', fontSize:'16px', color: calc.gameWinLoss < 0 ? '#dc2626' : '#0f172a' }}>
                {fmt(calc.gameWinLoss)}
              </span>
            </div>

            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>Total Rolling</span>
              <span>{fmt(calc.rollingAmount)}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>Commission %</span>
              <span>{game.rollingComm}%</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'20px', fontWeight:'bold', color:'#059669', fontSize:'15px' }}>
              <span>Rolling Commission</span>
              <span>{fmt(calc.rollingComm)}</span>
            </div>

            {game.type === 'Share' && (
              <>
                <div style={{ borderTop:'2px dashed #cbd5e1', margin:'20px 0' }}></div>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
                  <span>Net Win/Loss <span style={{fontSize:'11px', color:'#94a3b8'}}>(Win/Loss - Comm)</span></span>
                  <span style={{ fontWeight:'bold' }}>{fmt(calc.netWinLoss)}</span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
                  <span>Share %</span>
                  <span>{game.shareRate}%</span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', padding:'15px', background:'#ecfdf5', borderRadius:'6px', border:'1px solid #10b981', marginTop:'10px' }}>
                  <span style={{ fontWeight:'bold', color:'#047857' }}>Share Profit</span>
                  <span style={{ fontWeight:'bold', fontSize:'18px', color:'#047857' }}>{fmt(calc.shareProfit)}</span>
                </div>
              </>
            )}
        </div>

        {/* 서명란 */}
        <div style={{ display:'flex', justifyContent:'space-between', marginTop:'60px', paddingBottom: '20px' }}>
          <div style={{ textAlign:'center', width:'40%' }}>
            <div style={{ borderBottom:'1px solid #334155', height:'40px', marginBottom:'10px' }}></div>
            <span style={{ fontWeight:'bold', fontSize:'14px' }}>Cage</span>
          </div>
          <div style={{ textAlign:'center', width:'40%' }}>
            <div style={{ borderBottom:'1px solid #334155', height:'40px', marginBottom:'10px', display:'flex', alignItems:'flex-end', justifyContent:'center' }}>
                {agent ? `${agent.engSurname} ${agent.engGivenName}` : ''}
            </div>
            <span style={{ fontWeight:'bold', fontSize:'14px' }}>Agent</span>
          </div>
        </div>

        {/* 버튼들 */}
        <div className="no-print" style={{ position:'absolute', top:'20px', right:'20px', display:'flex', gap:'10px' }}>
          <button onClick={handlePrint} style={{ display:'flex', alignItems:'center', gap:'5px', padding:'10px 15px', background:'#dc2626', color:'white', border:'none', borderRadius:'6px', fontWeight:'bold', cursor:'pointer' }}>
            <Printer size={16}/> Print PDF
          </button>
          <button onClick={onClose} style={{ display:'flex', alignItems:'center', gap:'5px', padding:'10px 15px', background:'#64748b', color:'white', border:'none', borderRadius:'6px', fontWeight:'bold', cursor:'pointer' }}>
            <X size={16}/> Close
          </button>
        </div>
      </div>
      
      <style>{`
        @media print {
            @page { size: auto; margin: 0; }
            html, body { height: 1px !important; overflow: hidden !important; background: white !important; margin: 0 !important; padding: 0 !important; }
            body * { visibility: hidden; }
            #print-overlay, #print-overlay * { visibility: visible; }
            #print-overlay { position: absolute !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; margin: 0 !important; padding: 20px !important; background: white !important; z-index: 99999 !important; }
            .no-print { display: none !important; }
        }
      `}</style>
    </div>
  );
};

// --- [메인 컴포넌트] ---
const Settlement = () => {
  const { games, agents, currentUser } = useData(); // ★ currentUser 추가
  const { t } = useLang();
  const navigate = useNavigate();

  const [filterType, setFilterType] = useState('All');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedGame, setSelectedGame] = useState(null);

  const fmt = (num) => num ? Math.floor(Number(num)).toLocaleString() : '0';

  // ★ 관리자 여부 체크
  const userType = currentUser?.type || '';
  const isAdmin = 
      userType === 'Master_Admin' || 
      userType === 'Staff' || 
      userType.includes('Manager');

  // ★ 에이전트 클릭 핸들러 (페이지 이동)
  const handleAgentClick = (agentCode) => {
      navigate('/agents', { state: { targetAgentCode: agentCode } });
  };

  const filteredSettlements = games.filter(game => {
    if (game.status !== 'Settled') return false;
    
    // ★ 관리자가 아니면 본인 정산 내역만 조회
    if (!isAdmin && game.agentId !== currentUser.code) return false;

    if (filterType !== 'All' && game.type !== filterType) return false;

    const agent = agents.find(a => a.code === game.agentId);
    const searchTarget = (
        game.id + 
        (agent ? agent.code : '') + 
        (agent ? agent.engSurname + agent.engGivenName : '') + 
        (agent ? agent.nativeName : '')
    ).toUpperCase();
    
    if (!searchTarget.includes(searchTerm.toUpperCase())) return false;

    const targetDateStr = game.endedAt || game.startedAt; 
    if (!targetDateStr) return false;
    
    const targetDate = new Date(targetDateStr).toISOString().split('T')[0];
    if (startDate && targetDate < startDate) return false;
    if (endDate && targetDate > endDate) return false;

    return true;
  });

  let totalBuyIn = 0; let totalCashOut = 0; let totalCommission = 0; let totalShareProfit = 0; 
  filteredSettlements.forEach(g => {
      const b = parseFloat(g.sumBuyIn || 0);
      const c = parseFloat(g.sumCashOut || 0);
      const r = parseFloat(g.totalRolling || 0);
      const comm = Math.floor(r * (parseFloat(g.rollingComm || 0) / 100));
      let share = 0;
      if (g.type === 'Share') {
          const net = (b - c) - comm;
          if (net > 0) share = Math.floor(net * (parseFloat(g.shareRate || 0) / 100));
      }
      totalBuyIn += b; totalCashOut += c; totalCommission += comm; totalShareProfit += share;
  });
  const totalWinLoss = totalBuyIn - (totalCashOut + totalCommission + totalShareProfit);

  const handleViewDetail = (gameId) => {
    const game = games.find(g => g.id === gameId);
    if (game) setSelectedGame(game);
  };
  const handleCloseModal = () => setSelectedGame(null);

  return (
    <div style={{ padding: '30px', color: '#1e293b' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>📑 {t('menu_reports')}</h2>
        <button onClick={() => window.print()} style={{ backgroundColor: '#dc2626', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '8px', fontWeight: 'bold', display:'flex', alignItems:'center', gap:'5px', cursor:'pointer' }}>
          <FileText size={18}/> {t('pdf')}
        </button>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', flexWrap:'wrap', gap:'10px' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['All', 'Rolling', 'Share', 'Credit'].map(type => (
            <button key={type} onClick={() => setFilterType(type)} 
              style={{ padding: '8px 16px', borderRadius: '20px', border: 'none', cursor: 'pointer', fontWeight: 'bold', backgroundColor: filterType === type ? '#0f172a' : '#e2e8f0', color: filterType === type ? 'white' : '#64748b', transition: 'all 0.2s' }}>
              {type === 'All' ? '전체' : type}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', background: 'white', border: '1px solid #ccc', borderRadius: '6px', padding: '5px 10px' }}>
                <Calendar size={16} color="#64748b" style={{ marginRight: '8px' }} />
                <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ border: 'none', outline: 'none', fontSize: '13px', color: '#334155', cursor:'pointer' }} />
                <span style={{ margin: '0 8px', color: '#64748b' }}>~</span>
                <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ border: 'none', outline: 'none', fontSize: '13px', color: '#334155', cursor:'pointer' }} />
            </div>
            <button onClick={() => { setStartDate(''); setEndDate(''); setSearchTerm(''); setFilterType('All'); }} title="초기화" style={{ padding: '8px', background: '#e2e8f0', border: 'none', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><RotateCcw size={16} color="#475569" /></button>
            <div style={{ position: 'relative' }}>
                <input value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Agent Name or Game ID" style={{ padding: '10px 10px 10px 35px', borderRadius: '6px', border: '1px solid #ccc', width: '250px' }} />
                <Search size={18} style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
            </div>
        </div>
      </div>

      {/* 요약 카드 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '15px', marginBottom: '20px' }}>
          <div style={{ background: 'white', padding: '20px', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100px' }}>
              <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 'bold', textAlign: 'left' }}>Total Buy-in</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0f172a', textAlign: 'right' }}>{fmt(totalBuyIn)}</div>
          </div>
          <div style={{ background: 'white', padding: '20px', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100px' }}>
              {/* [Label Change] Total Cash Out -> Total Chips Out */}
              <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 'bold', textAlign: 'left' }}>Total Chips Out</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#dc2626', textAlign: 'right' }}>{fmt(totalCashOut)}</div>
          </div>
          <div style={{ background: 'white', padding: '20px', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100px' }}>
              <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 'bold', textAlign: 'left' }}>Total Rolling Commission</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#d97706', textAlign: 'right' }}>{fmt(totalCommission)}</div>
          </div>
          <div style={{ background: 'white', padding: '20px', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100px' }}>
              <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 'bold', textAlign: 'left' }}>Total Share Profit</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#7c3aed', textAlign: 'right' }}>{fmt(totalShareProfit)}</div>
          </div>
          <div style={{ background: totalWinLoss >= 0 ? '#f0fdf4' : '#fef2f2', padding: '20px', borderRadius: '8px', border: totalWinLoss >= 0 ? '1px solid #bbf7d0' : '1px solid #fecaca', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100px' }}>
              <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 'bold', textAlign: 'left' }}>Net Win/Loss</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: totalWinLoss >= 0 ? '#16a34a' : '#dc2626', textAlign: 'right' }}>
                  {totalWinLoss >= 0 ? '+' : ''}{fmt(totalWinLoss)}
              </div>
          </div>
      </div>

      <div style={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', textAlign: 'center' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
              <th style={{ padding: '15px' }}>Date (Settled)</th>
              <th style={{ padding: '15px' }}>Game ID</th>
              <th style={{ padding: '15px' }}>Agent</th>
              <th style={{ padding: '15px' }}>Type</th>
              <th style={{ padding: '15px', textAlign: 'right' }}>Buy-in</th>
              <th style={{ padding: '15px', textAlign: 'right' }}>Chips Out</th>
              <th style={{ padding: '15px', textAlign: 'right' }}>Rolling Comm</th>
              <th style={{ padding: '15px', textAlign: 'right' }}>Share Profit</th>
              <th style={{ padding: '15px', textAlign: 'right' }}>Win/Loss</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>상세</th>
              <th style={{ padding: '15px' }}>Settled By</th>
            </tr>
          </thead>
          <tbody>
            {filteredSettlements.length > 0 ? (
                filteredSettlements.map((game) => {
                    const agent = agents.find(a => a.code === game.agentId);
                    
                    const calc = {
                        b: parseFloat(game.sumBuyIn || 0),
                        c: parseFloat(game.sumCashOut || 0),
                        r: parseFloat(game.totalRolling || 0),
                        comm: Math.floor(parseFloat(game.totalRolling||0) * (parseFloat(game.rollingComm||0) / 100)),
                    };
                    let share = 0;
                    if (game.type === 'Share') {
                        const net = (calc.b - calc.c) - calc.comm;
                        if (net > 0) share = Math.floor(net * (parseFloat(game.shareRate || 0) / 100));
                    }
                    const wl = calc.b - (calc.c + calc.comm + share);

                    return (
                      <tr key={game.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '15px', color:'#64748b' }}>
                            {game.endedAt ? new Date(game.endedAt).toLocaleDateString() : '-'}
                        </td>
                        <td style={{ padding: '15px', fontWeight: 'bold' }}>{game.id}</td>
                        <td style={{ padding: '15px', textAlign:'left' }}>
                            {agent ? (
                                // ★ [수정] 클릭 이벤트 및 스타일 적용됨
                                <div onClick={() => handleAgentClick(agent.code)} style={{ cursor: 'pointer' }}>
                                    <span style={{ fontWeight:'bold', color:'#2563eb', textDecoration:'underline' }}>{agent.code}</span>
                                    <div style={{ fontSize:'13px', color:'#1e293b' }}>
                                        {agent.engSurname} {agent.engGivenName}
                                        {agent.nativeName && <span style={{ color:'#64748b', marginLeft:'4px' }}>({agent.nativeName})</span>}
                                    </div>
                                </div>
                            ) : game.agentId}
                        </td>
                        <td style={{ padding: '15px' }}>
                            <span style={{ padding:'4px 10px', borderRadius:'12px', fontSize:'12px', fontWeight:'bold', background: game.type==='Rolling'?'#eff6ff': game.type==='Share'?'#fff7ed':'#f0fdf4', color: game.type==='Rolling'?'#1d4ed8': game.type==='Share'?'#c2410c':'#15803d' }}>
                                {game.type}
                            </span>
                        </td>
                        <td style={{ padding: '15px', textAlign: 'right' }}>{fmt(calc.b)}</td>
                        <td style={{ padding: '15px', textAlign: 'right', color:'#dc2626' }}>{fmt(calc.c)}</td>
                        <td style={{ padding: '15px', textAlign: 'right', color:'#d97706' }}>{fmt(calc.comm)}</td>
                        <td style={{ padding: '15px', textAlign: 'right', color:'#7c3aed' }}>{fmt(share)}</td>
                        <td style={{ padding: '15px', textAlign: 'right', fontWeight:'bold', color: wl >= 0 ? '#16a34a' : '#dc2626' }}>
                            {wl >= 0 ? '+' : ''}{fmt(wl)}
                        </td>
                        <td style={{ padding: '15px', textAlign: 'center' }}>
                            <button onClick={() => handleViewDetail(game.id)} style={{ backgroundColor: '#3b82f6', color: '#ffffff', padding: '6px 12px', borderRadius: '4px', fontSize: '13px', fontWeight: '500', border: 'none', cursor: 'pointer', display:'flex', alignItems:'center', gap:'4px', margin:'0 auto' }}>
                                <Eye size={14}/> 보기
                            </button>
                        </td>
                        <td style={{ padding: '15px', fontSize:'12px', color:'#64748b' }}>{game.settledBy || '-'}</td>
                      </tr>
                    );
                })
            ) : (
                <tr>
                    <td colSpan="11" style={{ padding: '30px', color: '#94a3b8' }}>해당 조건의 정산 내역이 없습니다.</td>
                </tr>
            )}
          </tbody>
        </table>
      </div>

      {selectedGame && (
        <SettlementDetailModal 
          game={selectedGame} 
          agent={agents.find(a => a.code === selectedGame.agentId)}
          onClose={handleCloseModal} 
        />
      )}
    </div>
  );
};

export default Settlement;